<template>
    <div class="window" :style="{border : '1px solid '+ Global.globalColor}">
        <slot></slot>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
      }
    },
    methods: {
    }
  }
  </script>
  <style scoped>
  .window {
    width: 100%;
    height: 100%;
    border-radius: calc(100vw * 15 / 1920);
    box-shadow:  0px 0px 12px rgba(0, 0, 0, 0.12)
  }
  </style>
